import { Component, Input, OnInit } from "@angular/core";
import { AggregateBindingObject, ChartConfigSansData } from "@tylertech/aggregates-module";
import { ICustomViewComponent } from "@tylertech/custom-view";
import { AggregateCriteria, IAggregate } from "@tylertech/tyler-api-types";
import { TooltipItem } from "chart.js";
@Component({
    selector: "general-ledger-departments-nearing-budget-limit",
    templateUrl: "./departmentsNearingBudgetLimitSmartCard.tmpl.html",
    styleUrls: [
        "./departmentsNearingBudgetLimitSmartCard.component.scss"
    ],
    standalone: false
})
export class DepartmentsNearingBudgetLimitSmartCardComponent implements OnInit, ICustomViewComponent<AggregateBindingObject>
{
    private _customDataBinding: AggregateBindingObject;
    set customDataBinding(value: AggregateBindingObject)
    {
        this._customDataBinding = value;
        this.isLoaded = !!value;
    }

    @Input("aggregate") _aggregate: IAggregate;
    @Input("aggregateCriteria") _aggregateCriteria: AggregateCriteria;
    chartConfiguration: ChartConfigSansData;

    isLoaded: boolean;

    get aggregate(): IAggregate { return this._customDataBinding.aggregate || this._aggregate; }
    get aggregateCriteria(): AggregateCriteria { return this._customDataBinding.aggregateCriteria || this._aggregateCriteria; }

    ngOnInit(): void
    {
        this.chartConfiguration = {
            type: "bar",
            options: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: "y",
                plugins: {
                    legend: {
                        display: false,
                        labels: {
                            color: "#333333"
                        }
                    },
                    tooltip: {
                        mode: "dataset",
                        intersect: true,
                        position: "average",
                        callbacks: {
                            label: (tooltipItem: TooltipItem<"bar">): string | string[] =>
                            {
                                const chart = tooltipItem.chart;
                                const data = chart.data;
                                const value = data.datasets.length === 1
                                    ? this.GetOverBudgetValue(data.datasets[tooltipItem.datasetIndex].label)
                                    : data.datasets[tooltipItem.datasetIndex].data[tooltipItem.dataIndex];
                                return `${value}%`;
                            },
                            title: (tooltipItems: Array<TooltipItem<"bar">>): string | string[] =>
                            {
                                const first = tooltipItems[0];
                                const chart = first.chart;
                                const data = chart.data;
                                return this.GetLabel(data.datasets[first.datasetIndex].label);
                            },
                        },
                        backgroundColor: '#ffffff',
                        borderColor: '#767676',
                        borderWidth: 1
                    },
                },
                elements: {
                    line: {
                        fill: false
                    }
                },
                scales: {
                    x: {
                        stacked: true,
                        display: true,
                        grid: { display: true },
                        beginAtZero: true,
                        max: 100,
                        ticks: {
                            stepSize: 25,
                        },
                    },
                    y: {
                        stacked: true,
                        display: false,
                        grid: { display: false },
                    },
                },
            },
        };
    }

    private GetLabel(label: string): string
    {
        return label.split(" - ")[0];
    }

    private GetOverBudgetValue(label: string): string
    {
        return label.split(" - ")[1];
    }
}
